var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-results-chart"},[_c('GenericGameStatsChart',{attrs:{"title":"Games by result","labels":_vm.labels,"chart-data":_vm.chartData,"options":_vm.chartOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }